import { ArrowUpRight, MessageCircle, MessagesSquare } from "lucide-react";
import { useI18n } from "../../../i18n";
import { useContent } from "../hooks";
import { ChatThread } from "../../../components/common/ChatThread";

const Channel = ({ href, icon: Icon, title, sub, tone, testId }) => (
  <a href={href} target="_blank" rel="noreferrer" data-testid={testId} className="flex items-center gap-4 rounded-2xl bg-white p-4 shadow-sm transition-shadow duration-200 hover:shadow-lg">
    <span className={`grid h-11 w-11 shrink-0 place-items-center rounded-2xl ${tone}`}><Icon className="h-5 w-5" /></span>
    <div className="min-w-0 flex-1"><p className="text-sm font-semibold text-navy">{title}</p><p className="text-xs text-slate-500">{sub}</p></div>
    <ArrowUpRight className="h-5 w-5 text-slate-400" />
  </a>
);

const refreshBadge = () => window.dispatchEvent(new Event("vavlis:chat"));

export default function Chat() {
  const { t } = useI18n();
  const content = useContent();
  const chat = content.data?.chat || {};
  return (
    <div className="space-y-4" data-testid="chat-page">
      <div><h1 className="text-2xl font-bold text-navy sm:text-3xl">{t("chat.title")}</h1><p className="mt-1 text-sm text-slate-500">{t("x.chat.sub")}</p></div>
      <div className="h-[calc(100dvh-17rem)] min-h-[360px]"><ChatThread url="/chat/me" side="customer" onRead={refreshBadge} /></div>
      {(chat.whatsapp_number || chat.respondio_url) && (
        <div className="grid gap-3 md:grid-cols-2">
          {chat.whatsapp_number && <Channel href={`https://wa.me/${chat.whatsapp_number}`} icon={MessageCircle} title={t("chat.whatsapp")} sub={t("chat.whatsappSub")} tone="bg-brand/20 text-navy" testId="chat-whatsapp-link" />}
          {chat.respondio_url && <Channel href={chat.respondio_url} icon={MessagesSquare} title={t("chat.respondio")} sub={t("chat.respondioSub")} tone="bg-vblue/15 text-vblue-ink" testId="chat-respondio-link" />}
        </div>
      )}
    </div>
  );
}
